var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('QrcodeVue',_vm._b({attrs:{"value":_vm.value}},'QrcodeVue',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }